import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames'
import { getSafe } from '@/helpers/global';
import icon_select_normal from '@/assets/images/icons/icon_select_normal.png'
import icon_select_hit from '@/assets/images/icons/icon_select_hit.png'
import Dropdown from '@/components/Dropdown/Dropdown'
import { utilsFunction } from '@/helpers/functions'
import Tips from '../../../Tips/Tips';
import { tipsType } from '@/constants/tips-type';


const INTEREST = "I", FIXED = "F";

class Margin extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      financingPlan: FIXED,
      fixedIndex: 0,
      refAmount: '',
      otherNumberSharesApply: '',
      otherMarginPercentage: '',
      marginData: [],
      InterestObj: {},
      FixedObj: {},
      loanAmount:'',
    }
  }

  selectSharesNumber = (type, index = '') => {
    this.setState({
      financingPlan: type,
      fixedIndex: index
    })
  }

  changeRefAmount = (val) => {
    this.setState({
      refAmount: val[0].overrideAmount,
      otherNumberSharesApply: val[0].value,
      financingPlan: INTEREST
    }, () => {
      this.setTempData()
    })
  }

  toGetInterestRate= (val)=>{
    let { marginBottom } = this.props
    let amount = val, firstAmount =''
    if(marginBottom.interestRateFeeList.length === 2){
      marginBottom.interestRateFeeList.map((item, index) => {
        if(item.interestRate === '-1.00' || item.interestRate === '-1'){
          firstAmount = item.loanAmtLessThan + 1
        }else{
          if(Number(amount) >= Number(firstAmount) && Number(amount) <= Number(item.loanAmtLessThan)){
            this.setState({
              interestRate: item.interestRate,
              interestRateBasis: item.interestRateBasis
            })
          }else{
            this.setState({
              interestRate: '-1.00',
              interestRateBasis: '0.00'
            })
          }
        }
      })
    }else if(marginBottom.interestRateFeeList.length > 2){
      marginBottom.interestRateFeeList.map((item, index) => {
        if(item.interestRate === '-1.00' || item.interestRate === '-1'){
          firstAmount = item.loanAmtLessThan + 1
        }else{
          if(Number(amount) >= Number(firstAmount) && Number(amount) <= Number(item.loanAmtLessThan)){
            this.setState({
              interestRate: item.interestRate,
              interestRateBasis: item.interestRateBasis
            })
          }else if (Number(marginBottom.interestRateFeeList[index - 1].loanAmtLessThan) + 1 < Number(amount) && Number(amount) < Number(item.loanAmtLessThan)){
            this.setState({
              interestRate: item.interestRate,
              interestRateBasis: item.interestRateBasis
            })
          }else{
            this.setState({
              interestRate: '-1.00',
              interestRateBasis: '0.00'
            })
          }
        }
      })
    }else{
      this.setState({
        interestRate: '-1.00',
        interestRateBasis: '0.00'
      })
    }
    this.setState({
      financingPlan: INTEREST
    }, () => {
      this.setTempData()
    })
  }

  changeMarginPercentage = (val) => {
    this.setState({
      otherMarginPercentage: val[0].value,
      financingPlan: INTEREST
    }, () => {
      this.setTempData()
    })
  }
  getLoanAmount =(e)=>{
    this.setState({
      loanAmount: e.target.value,
      financingPlan: INTEREST
    }, () => {
      this.toGetInterestRate(this.state.loanAmount)
      this.setTempData()
    })
  }



  setTempData = () => {
    const { marginBottom, applyDataResp } = this.props;
    const { fixedIndex, financingPlan, otherMarginPercentage, otherNumberSharesApply, refAmount, interestRateBasis, interestRate,loanAmount } = this.state
    let depositRate = '', applyShare = '', feeAmount = '';

    if (financingPlan === FIXED) {
      if (marginBottom.fixedChargeList.length === 0) return
      depositRate = marginBottom.fixedChargeList[fixedIndex].depositRate
      applyShare = marginBottom.fixedChargeList[fixedIndex].applyShare
      feeAmount = marginBottom.fixedChargeList[fixedIndex].feeAmt
      let FixedObj = {
        lendingPercentage: marginBottom.fixedChargeList[fixedIndex].lendingPercentage,
        fixedCharge: feeAmount,
        applyShare: applyShare
      }
      this.setState({
        FixedObj: FixedObj
      })
    }
    if (financingPlan === INTEREST) {
      let InterestObj = {
        // lendingPercentage: otherMarginPercentage,
        interestRateBasis: interestRateBasis,
        interestRate: interestRate,
        loanAmount:loanAmount,
      }
      this.setState({
        InterestObj: InterestObj
      })
    }
    let data = [
      // { label: 'ipo_margin_apply_margin_percentage', value: financingPlan === FIXED ? Number(depositRate) : Number(otherMarginPercentage) },
      { label: 'ipo_margin_apply_margin_loan_amount', value: utilsFunction.formatNumber(loanAmount,2) },
      { label: 'common_number_of_shares_apply', value: financingPlan === FIXED ? utilsFunction.currencyFormatter(applyShare, 0) : utilsFunction.currencyFormatter(otherNumberSharesApply, 0) },
      { label: 'common_subscription_amount', value: financingPlan === FIXED ? utilsFunction.formatNumber(applyDataResp.consideration,2) : utilsFunction.formatNumber(refAmount,2) },
      { label: 'ipo_service_charge', value: utilsFunction.formatNumber(applyDataResp.handlingFee,2) },
      { label: 'ipo_facility_fee', value: utilsFunction.formatNumber(applyDataResp.facilityFee,2) },
      { label: 'ipo_interest_rate', value: this.state.interestRate ? (utilsFunction.formatNumber(this.state.interestRate, 2)  + '%') : '-' },
    ]

    this.setState({
      marginData: data,
    })

  }

  componentDidUpdate(preProps, preState) {
    const { marginBottom } = this.props;
    const { financingPlan } = this.state;
    if (preProps.marginBottom && preProps.marginBottom !== marginBottom) {
      if (marginBottom.fixedChargeList === []) {
        this.selectSharesNumber(INTEREST)
      }
    }

    if (preState.financingPlan && financingPlan !== preState.financingPlan && financingPlan === INTEREST) {
      this.changeRefAmount(this.sharesApply.props.selectedOptions)
      // this.changeMarginPercentage(this.lendingPercentRef.props.selectedOptions)
    } else if (preState.financingPlan && financingPlan !== preState.financingPlan && financingPlan === FIXED) {
      this.setTempData()
    }
  }

  componentDidMount() {
    this.setTempData()
    this.selectSharesNumber(INTEREST)
  }

  reSetMargin() {
    const { marginBottom, marginLotSpreadList } = this.props;
    this.setState({
      loanAmount:''
    })
    this.selectSharesNumber(INTEREST)
    if (marginLotSpreadList.length > 0) {
      this.sharesApply.setValue([marginLotSpreadList[0]])
    }
    // if (marginBottom.fixedChargeList !== []) {
    //   this.selectSharesNumber(FIXED, 0)
    // } else {
    //   this.selectSharesNumber(INTEREST)
    //   if (marginLotSpreadList.length > 0) {
    //     this.sharesApply.setValue([marginLotSpreadList[0]])
    //   }
    //   if (lendingPercentList.length > 0) {
    //     this.lendingPercentRef.setValue([lendingPercentList[0]])
    //   }
    //   this.changeRefAmount(0)
    //   this.changeMarginPercentage(0)
    // }
  }

  render() {
    const { language, marginTopData, marginBottom, marginLotSpreadList, marginFailTips } = this.props;
    const { financingPlan, fixedIndex, refAmount,loanAmount } = this.state;
    return (
      <React.Fragment>
        <section className={classnames('margin-container')}>
          <div className="table-box">
            {
              marginTopData.map((item, index) =>
                <div className="row" key={index}>
                  <div className="key">{getSafe(() => language[item.label])}</div>
                  <div className="value">{item.value}</div>
                </div>
              )
            }
          </div>
          <div className="bottom">
            <div style={{display:'none'}}>
              {getSafe(() => language.ipo_margin_apply_select_shares_number)}<span className="required">*</span>
            </div>
            {/* {
              marginBottom.fixedChargeList && marginBottom.fixedChargeList.map((item, index) =>
                <div className="option" key={index}>
                  <label onClick={() => this.selectSharesNumber(FIXED, index)}>
                    <img src={(financingPlan === FIXED && fixedIndex === index) ? icon_select_hit : icon_select_normal} alt="select" />
                  </label>
                  <div>
                    {getSafe(() => language.ipo_margin_apply_fixed_price).format(utilsFunction.currencyFormatter(item.applyShare, 0), item.currencyID, utilsFunction.currencyFormatter(item.feeAmt,2), Number(item.depositRate))}
                  </div>
                </div>
              )
            } */}
            <div className="option">
              <label onClick={() => this.selectSharesNumber(INTEREST)} style={{display:'none'}}>
                <img src={financingPlan === INTEREST ? icon_select_hit : icon_select_normal} alt="select" />
              </label>
              <div>
                <div style={{display:'none'}}>
                  {getSafe(() => language.ipo_margin_apply_other_loan_amounts)}
                </div>
                    <div className="other-container">
                      <li>
                        <div className="key">{getSafe(() => language.ipo_margin_apply_loan_amount)}</div>
                        {marginBottom.interestRateFeeList && marginBottom.interestRateFeeList.map((item, index) =>
                          (item.interestRate === '-1.00' || item.interestRate === '-1') ? '' :
                          <div className="value" key={index}>{index === 0 ? `0 - ${utilsFunction.currencyFormatter(item.loanAmtLessThan,2)}` : `${utilsFunction.currencyFormatter(+marginBottom.interestRateFeeList[index - 1].loanAmtLessThan + 1,2)} - ${utilsFunction.currencyFormatter(item.loanAmtLessThan,2)}`}</div>
                        )}
                      </li>
                      <li>
                        <div className="key">{getSafe(() => language.ipo_margin_apply_interest_rate)}</div>
                        {marginBottom.interestRateFeeList && marginBottom.interestRateFeeList.map((item, index) =>
                          (item.interestRate === '-1.00' || item.interestRate === '-1') ? '' :
                          <div className="value" key={index}>{((item.interestRate * 1000) + (item.interestRateBasis * 1000)) / 1000}%</div>
                        )}
                      </li>
                    </div>
                    <div style={{paddingLeft:'20px',marginTop:'10px'}}>
                      <div><span style={{color:'#e64033'}}>*</span>{getSafe(() => language.ipo_margin_remark)} {' '}{' '} 90</div>
                    </div>
              </div>
            </div>
          </div>
          {financingPlan === INTEREST && marginLotSpreadList && <div className="table-box" style={{ border: '0 none' }}>
            <div className="row">
              <div className="key">{getSafe(() => language.ipo_margin_apply_margin_loan_amount)}<span className="required">*</span></div>
              <div className="value">
                <input type='text' onChange={(e)=>this.getLoanAmount(e)} value ={loanAmount} autoComplete="off" style={{height:'27px'}}/>
              {/* <Dropdown style={{ height: '100%' }}
                innerRef={e => this.lendingPercentRef = e}
                selectedOptions={[lendingPercentList[0]]}
                options={lendingPercentList}
                onChange={(val) => this.changeMarginPercentage(val)}
              /> */}
              </div>
            </div>
            <div className="row">
              <div className="key">{getSafe(() => language.ipo_margin_apply_number_shares_apply)}<span className="required">*</span></div>
              <div className="value"><Dropdown style={{ height: '100%' }}
                innerRef={e => this.sharesApply = e}
                selectedOptions={[marginLotSpreadList[0]]}
                options={marginLotSpreadList}
                onChange={(val) => this.changeRefAmount(val)}
              /></div>
            </div>
            <div className="row">
              <div className="key">{getSafe(() => language.common_reference_amount)}</div>
              <div className="value">{utilsFunction.formatNumber(refAmount,2)}</div>
            </div>
            {
               marginFailTips && <Tips isNoBgColor type={tipsType.error} style={{ fontSize: '12px' }}>
              {this.props.marginErrorMsg}
              </Tips>
            }
          </div>

          }

        </section>
      </React.Fragment>
    )
  }
}

Margin.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(Margin)
